import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const MenuDashboard = ({setAnchorEl,anchorEl,label1,label2,value1,value2,filtre1,filtre2,link1,link2,candidat,candidatInterview,candidatUnread,candidatRetenu,filtreFactureExpertNonPaye,filtreFactureClientNonPaye}) => {
    MenuDashboard.propTypes = {
        anchorEl: PropTypes.any,
        setAnchorEl:PropTypes.func,
        label1: PropTypes.any,
        label2: PropTypes.any,
        value1: PropTypes.any,
        value2: PropTypes.any,
        filtre1: PropTypes.any,
        filtre2: PropTypes.any,
        link1: PropTypes.any,
        link2: PropTypes.any,
        candidat: PropTypes.any,
        candidatInterview:PropTypes.any,
        candidatUnread:PropTypes.any,
        candidatRetenu:PropTypes.any,
        filtreFactureExpertNonPaye:PropTypes.any,
        filtreFactureClientNonPaye:PropTypes.any,
    };
    const { i18n } = useTranslation();
    const handleMenuClose = () => {
        // Close the menu
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const handleMenuOptionClick = (link, filtre, candidat, candidatInterview, candidatUnread, candidatRetenu, filtreFactureExpertNonPaye, filtreFactureClientNonPaye) => {
        let url = link;

        if (candidat)
            url += `?filtreCandidat=${filtre}`;
        else if (candidatInterview)
            url += `?filtreCandidatInterview=${candidatInterview}`;
        else if (candidatUnread)
            url += `?filtreCandidatUnread=${candidatUnread}`;
        else if (candidatRetenu)
            url += `?candidatRetenu=${candidatRetenu}`;
        else if (filtreFactureExpertNonPaye)
            url += `?filtreFactureExpertNonPaye=${filtreFactureExpertNonPaye}`;
        else if (filtreFactureClientNonPaye)
            url += `?filtreFactureClientNonPaye=${filtreFactureClientNonPaye}`;
        else
            url += `?filtre=${filtre}`;

        navigate(url, { replace: true });
        handleMenuClose();
    };
    return (
        <div>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                {/* Your MenuItem components with click events */}
                <MenuItem
                    onClick={() => handleMenuOptionClick(link1,filtre1,candidat,candidatInterview,candidatUnread,candidatRetenu,filtreFactureExpertNonPaye,filtreFactureClientNonPaye)}
                    disabled={filtre1}
                >{i18n.t(label1)+' '+value1}</MenuItem>
                <MenuItem
                    onClick={() => handleMenuOptionClick(link2,filtre2,candidat,candidatInterview,candidatUnread,candidatRetenu,filtreFactureExpertNonPaye,filtreFactureClientNonPaye)}
                    disabled={filtre2}
                >{i18n.t(label2)+' '+value2}</MenuItem>
                {/* Add more MenuItem components as needed */}
            </Menu>
        </div>
    );
};

export default MenuDashboard;